export default function(){
  this.setState({
    defaultAccountDataStagedChanges: undefined,
    updatingDefaultAccountDataError: undefined,
  })
}
